import { Request } from 'api';
import { AxiosResponse } from 'axios';

interface UpdateProfileRequest {
    athletic_net_profile_url: string | null;
}

type ReturnType = Promise<AxiosResponse<any>>;

const updateAthleticNetProfile = (
    individualUuid: string,
    data: UpdateProfileRequest,
): ReturnType => {
    return Request.put(`/individuals/${individualUuid}/athletic-net-profile`, data);
};

export default updateAthleticNetProfile;
